<micro-select-combo #sel
              placeholder="HTTP Authetication Types"
              [mode]="mode"
              [(id)]="authType"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              [blur]="onTouched">
</micro-select-combo>
